const updateDocumentTreeIds = (tree, localToExternalIds) => {
  const treeId = tree.id && localToExternalIds.has(tree.id) ? localToExternalIds.get(tree.id) : tree.id;
  return tree
    .set("id", treeId)
    .update("children", children => children.map(c => updateDocumentTreeIds(c, localToExternalIds)));
};

export default updateDocumentTreeIds;
